define('lq/events/actions/wordExportCommand',[
    'lq/events/actions/eventAction',
    'jquery',
    'lq',
    'lq/cookie',
    'lq/formSubmission'
], function (EventAction, $, lq, cookie, FormSubmission) {
    'use strict';

    function WordExportCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(WordExportCommand, EventAction);

    WordExportCommand.typeName = 'WordExportCommand';

    WordExportCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    WordExportCommand.prototype.createEventActionRequest = function() {
        if (this.eventData.downloadOnly)
            return undefined;

        return {
            eventActionType: 'WordExport',
            command: this.eventData.command
        };
    };

    WordExportCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (this.eventData.downloadOnly) {
            var token = 'word-export-' + Date.now();

            var form = new FormSubmission(this.piping.url.prepare(lq.getTenantUrl('Export/Word')));
            form.addProperty('actionId', this.piping.actionId);
            form.addProperty('wordExportId', this.eventData.command);
            form.addProperty('token', token);
            form.addParameters('parameters', this.piping.parameters.getNonSystemParameters());
            form.submit();

            var waitWhileDownloadIsStarting = function() {
                if (cookie.get(token) === null)
                    setTimeout(waitWhileDownloadIsStarting, 200);
                else
                    continuation();
            };
            waitWhileDownloadIsStarting();
        } else if (eventActionResponse.download) {
            var queryString = {
                url: eventActionResponse.url,
                filename: eventActionResponse.filename,
                openInBrowser: false
            };
            window.location = this.piping.url.prepare(lq.getTenantUrl('DynamicContent/DownloadFile'), queryString);
            continuation();
        } else {
            continuation();
        }
    };

    return WordExportCommand;
});
